import { z } from 'zod';
import { QueueAction } from '@rossum/api-client/schemas';
import {
  IconBan,
  IconCircleCheck,
  IconClock,
  IconCustomExport,
  IconTrash,
} from '@rossum/ui/icons/tabler';

const methods = ['postpone', 'export', 'delete', 'confirm', 'reject'] as const;

const documentStateActionPayloadSchema = z.object({
  method: z.enum(methods).nullable().default(null),
});

export const postponeAction = {
  icon: IconClock,
  intlKey: 'documentAction.postpone' as const,
  groupIntlKey: 'documentActions' as const,
  resolveAction: (a: QueueAction) =>
    a.type === 'change_status' &&
    documentStateActionPayloadSchema.parse(a.payload).method === 'postpone',
  serialized: {
    type: 'change_status' as const,
    payload: { method: 'postpone' },
  },
  form: () => null,
  header: () => null,
  supportedEvents: ['annotation_imported'] as const,
  payloadSchema: (_intl: unknown) => documentStateActionPayloadSchema,
};

export const exportAction = {
  icon: IconCustomExport,
  intlKey: 'documentAction.export' as const,
  groupIntlKey: 'documentActions' as const,
  resolveAction: (a: QueueAction) =>
    a.type === 'change_status' &&
    documentStateActionPayloadSchema.parse(a.payload).method === 'export',
  serialized: { type: 'change_status' as const, payload: { method: 'export' } },
  form: () => null,
  header: () => null,
  supportedEvents: ['annotation_imported'] as const,
  payloadSchema: (_intl: unknown) => documentStateActionPayloadSchema,
};

export const deleteAction = {
  icon: IconTrash,
  intlKey: 'documentAction.delete' as const,
  groupIntlKey: 'documentActions' as const,
  resolveAction: (a: QueueAction) =>
    a.type === 'change_status' &&
    documentStateActionPayloadSchema.parse(a.payload).method === 'delete',
  serialized: { type: 'change_status' as const, payload: { method: 'delete' } },
  form: () => null,
  header: () => null,
  supportedEvents: ['annotation_imported', 'annotation_import_failed'] as const,
  payloadSchema: (_intl: unknown) => documentStateActionPayloadSchema,
};

export const confirmAction = {
  icon: IconCircleCheck,
  intlKey: 'documentAction.confirm' as const,
  groupIntlKey: 'documentActions' as const,
  resolveAction: (a: QueueAction) =>
    a.type === 'change_status' &&
    documentStateActionPayloadSchema.parse(a.payload).method === 'confirm',
  serialized: {
    type: 'change_status' as const,
    payload: { method: 'confirm' },
  },
  form: () => null,
  header: () => null,
  supportedEvents: ['annotation_imported'] as const,
  payloadSchema: (_intl: unknown) => documentStateActionPayloadSchema,
};

export const rejectAction = {
  icon: IconBan,
  intlKey: 'documentAction.reject' as const,
  groupIntlKey: 'documentActions' as const,
  resolveAction: (a: QueueAction) =>
    a.type === 'change_status' &&
    documentStateActionPayloadSchema.parse(a.payload).method === 'reject',
  serialized: { type: 'change_status' as const, payload: { method: 'reject' } },
  form: () => null,
  header: () => null,
  supportedEvents: ['annotation_imported'] as const,
  payloadSchema: (_intl: unknown) => documentStateActionPayloadSchema,
};

export const documentStateActions = [
  postponeAction,
  rejectAction,
  confirmAction,
  exportAction,
  deleteAction,
];
